import { RouteObject } from 'react-router';

import { ProfileGateway } from '@vp/profile/ui/gateway/ProfileGateway';

export const ProfileRouter: RouteObject = {
  path: 'p/:id',
  element: <ProfileGateway />,
};
